/* raw layout hash: _station-locator-availability-layout:4d7572eee335ffb7d9478b590fbdd3b0e723f9f8ccdd747e3b03d89c4090fd29 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _station-locator-availability-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function StationLocatorAvailabilityLayout() {
  return <AppShell />;
}
